import { Button, ButtonGroup } from '@ps-smart-cp/ppfw-client';

interface CarryOverButtonsProps {
  onExecuteInstructionClick: () => void;
  onBackClick: () => void;
  onResetClick: () => void;
  executeInstruction: string;
  reset: string;
  backToConfirmationScreen: string;
  disabled: boolean;
}

export function CarryOverButtons({
  onExecuteInstructionClick,
  onBackClick,
  onResetClick,
  executeInstruction,
  reset,
  backToConfirmationScreen,
  disabled,
}: CarryOverButtonsProps) {
  return (
    <ButtonGroup alignment="right">
      <Button label={executeInstruction} onClick={onExecuteInstructionClick} disabled={disabled} />
      <Button label={reset} onClick={onResetClick} disabled={disabled} />
      <Button label={backToConfirmationScreen} onClick={onBackClick} disabled={disabled} />
    </ButtonGroup>
  );
}
